module.exports = __webpack_public_path__ + "static/media/mens-watchOne.23e42a1f.jpeg";